// Svelte 5 no longer needs svelte/store imports for basic reactivity

function loadEditorSettingsFromLocalStorage() {    let editorSettings = JSON.parse(localStorage.getItem("cc-editor-defaults")) || {
        insertStartOnInsert: true,
        insertEndOnInsert: false,
        selectNextEvent: false,
        autoChain: false,
        autoLineBreak: false,
        autoInsertEvent: false,
        pauseWhileType: false,
        pauseWhileTypeDuration: 500,
        autoTrimEvent: false,
        snapToShotChanges: true,
        snapToRegions: true,
        minFrameGap: 0,
        autoFormatText: false,
        updateTimeOnEdit: true,
        drawEvents: true,
        timelineFontSize: 12,
        timelineFontColor: "#ffffff",
        timelineOverlapProtection: true,
        showMarkerComment: true,
        showFilmstrip: false,
        filmstripFrameCount: 12,
        speakerAssignmentBehavior: "never"
    };

    editorSettings.editing = false; //keep track of editing state
    editorSettings.speakerAssignmentBehavior = editorSettings.speakerAssignmentBehavior || "never"; // Ensure default value
    editorSettings.showFilmstrip = editorSettings.showFilmstrip ?? false; // Konva timeline: desktop film strip row
    const parsedFrameCount = Number(editorSettings.filmstripFrameCount);
    editorSettings.filmstripFrameCount = Number.isFinite(parsedFrameCount)
        ? Math.min(30, Math.max(1, Math.round(parsedFrameCount)))
        : 12; // frames before/after the selected event start (1-30)
    editorSettings.snapToRegions = editorSettings.snapToRegions ?? true; // Konva timeline: snap to event edges
    return editorSettings;
}

// Default filter state (session-only, not persisted to localStorage)
function getDefaultFilterState() {
    return {
        panelVisible: false, // Controls UI visibility of filter panel
        text: "",
        hasError: false,
        hasMissingTimecode: false,
        hasForced: false, // Filter for forced events
        hasNonForced: false, // Filter for non-forced events (forced === false)
        hasFailedApproval: false, // Filter for events with failed approval (approved === false)
        hasApproved: false, // Filter for approved events (approved === true)
        hasNeedsReview: false, // Filter for events needing review (approved === undefined)
        hasIncompleteComment: false, // Filter for events with unchecked notes/replies
        lineCounts: [], // Array of line counts to match (4 means "4 or more")
        speakers: [], // Array of speaker IDs/names
        tags: [] // Array of tag names
    };
}

// Create reactive state for editor settings
export const editorState = $state(loadEditorSettingsFromLocalStorage());

// Session-only filter state (separate from persisted settings)
export const filterState = $state(getDefaultFilterState());

// Function to reset all filters to default (also closes panel)
export function resetFilters() {
    const defaults = getDefaultFilterState();
    Object.keys(defaults).forEach(key => {
        filterState[key] = defaults[key];
    });
}

// Function to check if any filters are active (has filter values set)
export function hasActiveFilters() {
    return (
        filterState.text.trim() !== "" ||
        filterState.hasError ||
        filterState.hasMissingTimecode ||
        filterState.hasForced ||
        filterState.hasNonForced ||
        filterState.hasFailedApproval ||
        filterState.hasApproved ||
        filterState.hasNeedsReview ||
        filterState.hasIncompleteComment ||
        filterState.lineCounts.length > 0 ||
        filterState.speakers.length > 0 ||
        filterState.tags.length > 0
    );
}

// Function to save editor settings to localStorage
export function saveEditorSettings() {
    localStorage.setItem("cc-editor-defaults", JSON.stringify(editorState));
}